import history from 'routes/History/history';
import jwt_decode from 'jwt-decode';

import { NOT_AUTHENTICATED_HOME } from 'routes/constants';

import store from "store";
import { showWarningMessage } from "reducers/application/applicationActions";

import { NOTIFICATION_STORAGE, ACCESS_TOKEN_STORAGE, EXPIRES_AT_STORAGE, USERNAME_STORAGE, USER_STORAGE } from 'constants/storageConstants';

export default class Auth {
    constructor() {
    }

    setAuthData(payload) {
        this.setJWT(payload.token);
        this.setUser(payload.user);
    }

    setJWT(accessToken) {
        var jwtDecoded = jwt_decode(accessToken);
        localStorage.setItem(ACCESS_TOKEN_STORAGE, accessToken);
        let expiresAt = JSON.stringify(jwtDecoded.exp);
        localStorage.setItem(EXPIRES_AT_STORAGE, expiresAt);
        localStorage.setItem(USERNAME_STORAGE, jwtDecoded.sub);
    }

    setUser(user) {
        localStorage.setItem(USER_STORAGE, JSON.stringify(user));
    }

    setUserPicture(base64) {
        let user = this.getUser();
        user.photoUrl = base64;
        this.setUser(user);
    }

    getUser() {
        const user = localStorage.getItem(USER_STORAGE);
        if (user) {
            return JSON.parse(user);
        } else {
            return {
                id: "",
                name: "",
                photoUrl: "",
                username: "",
                signed : false,
                company: {}
            };
        }
    }


    persistNewNotification(notification) {
        let notifications = this.getNotifications();
        for(let n of notifications){
            if (n.id === notification.id)
                return;
        }
        console.log("persist notification: ", notification);
        notifications.push(notification)
        localStorage.setItem(NOTIFICATION_STORAGE, JSON.stringify(notifications));
    }

    getNotifications() {
        let notifications = localStorage.getItem(NOTIFICATION_STORAGE);
        return !notifications ? [] : JSON.parse(notifications);
    }

    getUnreadNotifications() {
        let notifications = this.getNotifications();
        let arr = [];
        for(let notification of notifications){
            if (notification.status === 'NOT_READ')
                arr.push(notification);
        }
        return arr;
    }

    getAllUnreadNotificationIds() {
        let notifications = this.getNotifications();
        let arr = [];
        for(let notification of notifications){
            // if (notification.status === 'NOT_READ')
                arr.push(notification.id);
        }
        return arr;
    }

    setAllAsRead() {
        let notifications = this.getNotifications();
        for(let notification of notifications){
            notification.status = 'READ';
        }
        localStorage.setItem(NOTIFICATION_STORAGE, JSON.stringify(notifications));
    }

    logout() {
        // localStorage.removeItem(ACCESS_TOKEN_STORAGE);
        // localStorage.removeItem(EXPIRES_AT_STORAGE);
        // localStorage.removeItem(USERNAME_STORAGE);
        // localStorage.removeItem(USER_STORAGE);
        localStorage.clear();
        history.push(NOT_AUTHENTICATED_HOME);
    }

    isAuthenticated() {
        if (localStorage.getItem(ACCESS_TOKEN_STORAGE) && localStorage.getItem(EXPIRES_AT_STORAGE)) {
            let expiresAt = localStorage.getItem(EXPIRES_AT_STORAGE);
            let now = Math.round(new Date().getTime() / 1000);
            console.log("now: " + now + " expiresAt: " + expiresAt);
            let res = now < expiresAt;
            if (res === false) {
                store.dispatch(showWarningMessage("Sesión Expirada."));
            }
            return res;
        } else {
            return false;
        }
    }
}


// WEBPACK FOOTER //
// ./src/auth/Auth.js